module.exports = __webpack_public_path__ + "img/58df4bd.jpg";